<template>
  <div>
    <v-data-table
      v-model="itensSelecionados"
      :headers="headers"
      :items="items"
      :items-per-page="-1"
      :search="search"
      fixed-header
      height="calc(100vh - 255px)"
      class="table-full-screen"
      show-select
      item-key="index"
    >
      <template v-slot:top>
        <div class="d-flex py-2 pl-3">
          <v-icon left>mdi-format-list-bulleted</v-icon>
          <p class="ma-0 subtitle-1 font-wieght-medium pt-1">
            Tempo de Cobertura por Fornecedores
          </p>

          <v-spacer />

          <template v-if="itensSelecionados.length > 0">
            <v-badge color="white" overlap class="mr-6">
              <template v-slot:badge>
                <span style="color: #000">{{itensSelecionados.length}}</span>
              </template>

              <v-btn color="error" @click="confirmarDelecao()">
                <v-icon left>mdi-delete</v-icon>
                Excluir
              </v-btn>
            </v-badge>
          </template>

          <template v-else>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquisa"
              dense
              single-line
              hide-details
              clearable
              outlined
              v-lazy-input:debounce="500"
              class="pr-4 pl-auto"
              style="max-width: 475px"
            ></v-text-field>
          </template>

          <v-btn class="primary mr-5" @click="dialogCadastroCurvasCompras = ! dialogCadastroCurvasCompras">
            <v-icon left>mdi-plus</v-icon>
            Configuração Geral
          </v-btn>

          <DialogCurvasFornecedoresFilial
            ref="dialog_curvas_fornecedores_filial_ref"
            :itemParaEdicao="editedItem"
            @atualizacao="buscarItems()"
            @dialog:fechado="editedItem = {}"
          />

          <dialog-curvas-compras
            v-model="dialogCadastroCurvasCompras"
            :itemParaEdicao="editedItem"
            @atualizar-lista="buscarItems()"
          />
        </div>
      </template>

      <template #item.data-table-select="{item}">
        <v-btn v-if="!itensSelecionados.includes(item)" icon @click="itensSelecionados.push(item)">
          <v-icon>mdi-checkbox-blank-outline</v-icon>
        </v-btn>

        <v-btn v-else icon @click="itensSelecionados = itensSelecionados.filter(sel => sel !== item)">
          <v-icon>mdi-checkbox-marked</v-icon>
        </v-btn>
      </template>

      <template v-slot:header.action="{item}">
        <div style="margin-left: 9px">Ações</div>
      </template>

      <template v-slot:item.tempo_cobertura="{item}">
        <span v-if="Number(item.tempo_cobertura)">
          {{ Helpers.formatarValor(item.tempo_cobertura) }} dias
        </span>

        <span v-else class="text-gray-800">Não cadastrado</span>
      </template>

      <template v-slot:item.cobertura_estoque_curva_a="{item}">
        <span v-if="Number(item.cobertura_estoque_curva_a)">
          {{ Helpers.formatarValor(item.cobertura_estoque_curva_a) }} dias
        </span>

        <span v-else class="text-gray-800">Não cadastrado</span>
      </template>

      <template v-slot:item.cobertura_estoque_curva_b="{item}">
        <span v-if="Number(item.cobertura_estoque_curva_b)">
          {{ Helpers.formatarValor(item.cobertura_estoque_curva_b) }} dias
        </span>

        <span v-else class="text-gray-800">Não cadastrado</span>
      </template>

      <template v-slot:item.cobertura_estoque_curva_c="{item}">
        <span v-if="Number(item.cobertura_estoque_curva_c)">
          {{ Helpers.formatarValor(item.cobertura_estoque_curva_c) }} dias
        </span>

        <span v-else class="text-gray-800">Não cadastrado</span>
      </template>

      <template v-slot:item.tempo_cobertura_por_filial="{item}">
        <ListaCoberturas
          :itens="item.tempo_cobertura_por_filial"
          :id_entidade="item.idfornecedor"
          entidade="fornecedore"
          @update:coberturas-filial="buscarItems"
        />
      </template>

      <template v-slot:item.action="{item}">
        <div class="d-flex align-center">
          <EscolhaEdicao
            :item="item"
            @edicao:geral="editarItem"
            @edicao:por-filial="abrirEdicaoPorFilial"
          />

          <v-btn icon @click="itensSelecionados = [item];confirmarDelecao()">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </div>
      </template>
    </v-data-table>

    <DialogConfirmacaoTempoCobertura
      v-model="dialogConfirmacaoExclusao"
      color="red"
      @confirmado="deleteItem()"
    >
      <template #body>
        <p v-text="'Deseja realmente excluir itens selecionados?'" />
      </template>
    </DialogConfirmacaoTempoCobertura>
  </div>
</template>

<script>
import DialogCurvasCompras from "./DialogCurvasFornecedor.vue"
import TempoCoberturaFornecedorAPI from "../../../../api/compras/TempoCoberturaPorFornecedor"
import DialogConfirmacaoTempoCobertura from "./DialogConfirmacaoTempoCobertura.vue"
import DialogCurvasFornecedoresFilial from "@/components/Parametrizacao/Cruds/CoberturaPorFornecedor/PorFilial/DialogCadastro.vue"
import ListaCoberturas from "@/components/Parametrizacao/Cruds/ListaCoberturas.vue";
import EscolhaEdicao from "@/components/Parametrizacao/Cruds/EscolhaEdicao.vue";

export default {
  name: 'Cobertura',
  components: {
    EscolhaEdicao,
    ListaCoberturas,
    DialogCurvasCompras,
    DialogConfirmacaoTempoCobertura,
    DialogCurvasFornecedoresFilial,
  },
  data: () => ({
    search: "",
    dialogCadastroCurvasCompras: false,
    dialogConfirmacaoExclusao: false,
    dialogConfirmacaoAplicar: false,
    headers: [
      { text: '#Id', value: 'id' },
      { text: 'Fornecedor', value: 'fornecedor'},
      { text: 'Usuário', value: 'usuario_log' },
      { text: 'Cobertura Padrão', value: 'tempo_cobertura', width: '150px' },
      { text: 'Cobertura Curva A', value: 'cobertura_estoque_curva_a', width: '150px' },
      { text: 'Cobertura Curva B', value: 'cobertura_estoque_curva_b', width: '150px' },
      { text: 'Cobertura Curva C', value: 'cobertura_estoque_curva_c', width: '150px' },
      { text: 'Tempo de Cobertura Por Filial', value: 'tempo_cobertura_por_filial', width: '250px' },
      { text: 'Ações', value: 'action', width: '100px' }
    ],
    editedItem: {},
    items: [],
    itensSelecionados: []
  }),
  watch: {
    dialogCadastro (dialog) {
      !dialog && (this.itensSelecionados = [])
    },
    dialogConfirmacaoAplicar (dialog) {
      !dialog && (this.itensSelecionados = [])
    },
    dialogConfirmacaoExclusao (dialog) {
      !dialog && (this.itensSelecionados = [])
    }
  },
  created() {
    this.buscarItems()
  },
  methods: {
    confirmarDelecao () {
      this.dialogConfirmacaoExclusao = true
    },
    editarItem (item) {
      this.dialogCadastroCurvasCompras = true
      this.editedItem = Object.assign({}, item)
    },
    abrirEdicaoPorFilial (item) {
      this.$refs.dialog_curvas_fornecedores_filial_ref.dialog_ativo = true;
      this.editedItem = Object.assign({}, item);
    },
    buscarItems () {
      const headers = this.Helpers.iniciarRequisicao();

      this.$store.dispatch(
        "loading/addRequisicao",
        TempoCoberturaFornecedorAPI.getListaFull(headers)
          .then((response) => {
            const {token, itens} = response.data;
            localStorage.token = token
            this.items = itens.map((item, index) => ({ ...item, index }));
          })
          .catch(() => this.Helpers.logout())
      );
    },
    deleteItem () {
      const headers = this.Helpers.iniciarRequisicao();

      const fornecedores = this.itensSelecionados.map(item => item.idfornecedor);

      this.$store.dispatch(
        "loading/addRequisicao",
        TempoCoberturaFornecedorAPI.deleteMultiplos(headers, { fornecedores })
          .then((response) => {
            const {token} = response.data;
            localStorage.token = token
            this.buscarItems()
          })
          .catch(() => this.Helpers.logout())
      );
    },
  }
}
</script>

<style>

</style>
